import React, { PureComponent } from 'react';
import EyeIcon from 'mdi-react/EyeIcon';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import {ApiService} from "../../../services/ApiService1";
import { clearCookies } from "../../../services/constants";
import PropTypes from 'prop-types';
import {Button} from "reactstrap";
import {message, Spin} from "antd";
import Cookies from 'universal-cookie';
import '../okta.scss';
// import Logo from "../../../shared/img/logo/kapstone.png";
// import Logo from "../../../shared/img/logo/AEP_LOGO.jpg";
import Logo from "../../../shared/img/logo/kp-cert-logo.jpeg";
import moment from "moment";

const cookies = new Cookies();

class LogInForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      showPassword: false,
      name: '',
      password: '',
      isLoading: false
    };
  }

  onChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState(({ showPassword: !this.state.showPassword }));
  };

  onLogin = async () => {
    this.setState({
      isLoading: true
    });
    const currentClientId = this.props.match.params.clientId;
    const {name, password} = this.state;
    // const payload = {
    //     requestToken: {
    //     registeredAppName: currentClientId,
    //     userid: name,
    //     password: password
    //   }
    // };
    const payload = { userName: name, password}
    const data = await ApiService.localLogin(payload)
    if(!data || data.error){
      this.setState({
        isLoading: false
      });
      return message.error('Invalid Credentials')
    } else {

      const value = moment().unix()
      localStorage.setItem('timestamp', value)
      const userPwdToken = btoa(`${name}:${password}`);
      clearCookies()
      cookies.set('USER_PWD_TOKEN', userPwdToken, { path: '/' });
      cookies.set('JWT_ACCESSTOKEN', data.cookies || "", { path: '/' });
      cookies.set('REGISTERED_APPNAME', currentClientId, { path: '/' });
      cookies.set('LOGGEDIN_USERID', name, { path: '/' });
      cookies.set('LAST_LOGIN', data.loginDateAndTime || "", { path: '/' });
      // await this.onRolesSet()
      const roles = await ApiService.getAdminUserRole();
      cookies.set('USER_ADMIN_ROLE', roles.userOperationalRole || "", { path: '/' });
      this.setState({
        isLoading: false
      });
      const role = cookies.get('USER_ADMIN_ROLE');
      const isEmployee = (role || "").includes("Manager")
      // window.location.href = isEmployee ? `/iga/${currentClientId}/request/request-for-self` : `/iga/${currentClientId}/`;
      window.location.href = isEmployee ? `/iga/${currentClientId}/certification` : `/iga/${currentClientId}/admin/dashboard`;
    }
  }

  onRolesSet = async () => {
    const roles = await ApiService.getAdminUserRole()
    if(!roles || roles.error){
      cookies.set('USER_ADMIN_ROLE', "", { path: '/' });
    } else if(roles === 'Manager') {
      cookies.set('USER_ADMIN_ROLE', roles.userOperationalRole || "", { path: '/' });
    }else {
      cookies.set('USER_ADMIN_ROLE', roles.userOperationalRole || "", { path: '/admin/dashboard' });
    }
  }

  onEnterPress = (press) => {
    const { name, password, isLoading } = this.state;
    if(press.key === "Enter" && name && password && !isLoading) {
      this.onLogin()
    }
  }

  render() {
    const { showPassword, name, password, isLoading } = this.state;
    return (
      <div className="login-page">
        {/*<div className="form">
          <div className="form__form-group">
            <span className="form__form-group-label">Username</span>
            <div className="form__form-group-field">
              <div className="form__form-group-icon">
                <AccountOutlineIcon />
              </div>
              <input
                  name="name"
                  value={name}
                  type="text"
                  onChange={this.onChange}
                  placeholder="Name"
                  onKeyPress={this.onEnterPress}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">Password</span>
            <div className="form__form-group-field">
              <div className="form__form-group-icon">
                <KeyVariantIcon />
              </div>
              <input
                  name="password"
                  onChange={this.onChange}
                  value={password}
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Password"
                  onKeyPress={this.onEnterPress}
              />
              <button
                  className={`form__form-group-button${showPassword ? ' active' : ''}`}
                  onClick={e => this.showPassword(e)}
                  type="button"
              ><EyeIcon />
              </button>
            </div>
          </div>
          <Button disabled={!name || !password || isLoading} color="primary" className="btn btn-primary account__btn account__btn--small" onClick={this.onLogin}>
            { isLoading ? <Spin style={{color: '#fff'}}/> : 'Sign In'}
          </Button>
        </div>*/}
        <div id="page-container">
          <section id="nav-wrapper" className="header header-fixed headroom headroom--top headroom--not-bottom"
                   role="banner">
            <div id="nav-top">
              <div className="row small-collapse">
                <div className="large-11 column">
                </div>

              </div>
            </div>

            <header id="nav-main" role="navigation">
              <div className="row">
                <div /* className="large-3 column" */ >
                  <img style={{height: 50, width: 200}} src={Logo} alt="Forward Air"/>
                </div>
                <div className="large-9 column menu">
                </div>
              </div>
            </header>

          </section>

          <div className="region region-content " id="content-wrap">
            <div className="auth-wrapper">
              <div className="auth-inner">
                <div className="row" id="premier-login-form">
                  <div className="large-12 column left">

                    <form action="https://ohstest.forwardair.com/oam/server/auth_cred_submit" method="post">
                      <div className="row form-group">
                        <div className="small-12 columns">
                          <h2 className="text-white">Sign-In to Application</h2>
                        </div>
                      </div>
                      <div className="row form-group">
                        <div className="small-12 columns">
                          <label htmlFor="username">Username:</label>
                        </div>
                        <div className="small-12 columns">
                          <input
                            name="name"
                            value={name}
                            type="text"
                            onChange={this.onChange}
                            placeholder="Name"
                            onKeyPress={this.onEnterPress}
                          />
                        </div>
                      </div>
                      <div className="row columns form-group">
                        <label htmlFor="password">Password:</label>
                        <input
                          name="password"
                          onChange={this.onChange}
                          value={password}
                          type={showPassword ? 'text' : 'password'}
                          placeholder="Password"
                          onKeyPress={this.onEnterPress}
                        />
                      </div>
                    </form>

                    <div className="row premier-buttons">
                      <div className="medium-12 columns">
                        <button
                          type="submit"
                          className="premier-signin-btn expanded button button-primary text-white"
                          onClick={this.onLogin}
                          disabled={!name || !password || isLoading}
                        >
                          { isLoading ? <Spin style={{color: '#fff', marginRight: 5}}/> : null } Sign-In
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="region region-footer footer">
            <footer id="footer">
              <div className="row">
                <div className="row" id="footer-btm">
                  <div className="columns footer-terms">
                    <p>2020. Please review our <a>Privacy
                      Policy</a> and <a>Terms of Use</a>.
                    </p>
                  </div>
                </div>
              </div>
            </footer>
          </div>

        </div>
      </div>
    );
  }
}

export default LogInForm;
